import React from "react";
import { Box, Image, Text, FormField, Input } from "@wix/design-system";
import { SURFACE_NEUTRAL_COLOR } from "@wix/picasso-common";

interface RecreateFormProps {
  image: string;
  isMobile: boolean;
  inputLabel: string;
  urlError: string | undefined;
  helperText: string | undefined;
  url: string;
  handleUrlChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  inputPlaceholder: string;
}
export const RecreateForm = ({
  image,
  isMobile,
  inputLabel,
  urlError,
  helperText,
  url,
  handleUrlChange,
  inputPlaceholder,
}: RecreateFormProps) => {
  return (
    <Box direction="vertical" gap={6} paddingBottom={6} paddingTop={6}>
      <Image
        style={{ backgroundColor: SURFACE_NEUTRAL_COLOR }}
        src={image}
        width="100%"
        height={isMobile ? "140px" : "191px"}
        borderRadius="8px"
      />
      <Box direction="vertical" gap={2}>
        <Text size="small" weight="normal">
          {inputLabel}
        </Text>
        <FormField
          statusMessage={urlError}
          status={urlError ? "error" : undefined}
        >
          <Input
            placeholder={inputPlaceholder}
            value={url}
            onChange={handleUrlChange}
            autoFocus={!isMobile}
          />
        </FormField>
        {!urlError && helperText && (
          <Text size="tiny" weight="thin">
            {helperText}
          </Text>
        )}
      </Box>
    </Box>
  );
};
